import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonText from "../button/ButtonText";
import ButtonBlue from "../button/ButtonBlue";
import {Button, Divider, IconButton} from "@mui/material";
import * as React from "react";
import {Container, styled} from "@mui/system";
import Toolbar from "@mui/material/Toolbar";
import {ReactComponent as UserIcon} from "../../../components/Icons/user.svg"
import {ReactComponent as UserLight} from "../../Icons/userLight.svg"
import {authorizedAdmin, authorizedOrganization} from "../../../Constants";
import {useNavigate} from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import {useMemo, useState} from "react";
import ButtonCatalog from "../button/ButtonCatalog";
import VersoMebelLogo from "../VersoMebelLogo";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {kuhniVersoTabletContainerQuerySx} from "../../../utils/isKuhniVersoMebelDomain";

const StyledToolbar = styled(Toolbar)(({theme}) => ({
    display: "flex",
    alignItems: "center",
    width: "100%",
    "&.MuiToolbar-root": {
        padding: 0
    }
}));

export const ToolbarFirst = ({profile, handleChange, requireAuthNavigate, isUpMe, domainName, accessibility, stage}) => {
    const isKuhniVersoMebel = domainName === "kuhni-verso-mebel.upme.by" || domainName === "kuhni-verso-mebel.t.upme.by"
    const navigate = useNavigate();
    const isOrganization = profile?.userRoles?.some(role => authorizedOrganization.includes(role.name))
    const isAdmin = profile?.userRoles?.some(role => authorizedAdmin.includes(role.name))
    const [userMenuAnchor, setUserMenuAnchor] = useState(null);
    const [burgerMenuAnchor, setBurgerMenuAnchor] = useState(null);
    const [blueSubMenu, setBlueSubMenu] = useState(null);

    const navItems = useMemo(() => {
        const items = [];
        if (!isKuhniVersoMebel) {
            items.push({label: "Помощь", path: "/help"});
        }
        if (isUpMe) {
            items.push({label: "Акции", path: "/stock"});
        }
        if (isKuhniVersoMebel) {
            items.push({label: "Каталог", path: "/catalog"});
            items.push({label: "Мои черновики", path: "/catalog/drafts"});
            if (profile) {
                items.push({label: "Мои заказы", path: "/customer/kitchen-orders"});
            }
            items.push({label: "Как сделать заказ?", path: "/how-to-order"});
        }
        if (isUpMe || isKuhniVersoMebel) {
            if (!isKuhniVersoMebel) {
                items.push({label: "Новости", path: "/news"});
            }
            items.push({label: "Контакты", path: "/contacts"});
        }
        if (isUpMe) {
            items.push({label: "Материалы", path: "/all-materials"});
            items.push({label: "Работа в UpMe", path: "/work"});
        }
        return items;
    }, [isKuhniVersoMebel, isUpMe, profile]);

    const blueBarMenus = useMemo(() => {
        if (!profile || (stage !== 0 && !(stage > 7)) || !accessibility?.menu?.length) {
            return [];
        }
        return accessibility.menu.map((menu) => ({
            type: menu.type,
            label: menu.name,
            subItems: accessibility.subMenu.filter((subMenu) => subMenu.menuType === menu.type),
        }));
    }, [profile, stage, accessibility]);

    const hasBurgerMenu = navItems.length > 0
        || blueBarMenus.length > 0
        || (profile && !isOrganization && !isAdmin && !isKuhniVersoMebel);

    const handleUserMenuClose = () => {
        setUserMenuAnchor(null);
    };

    const handleBurgerMenuClose = () => {
        setBurgerMenuAnchor(null);
        setBlueSubMenu(null);
    };

    const handleBlueSubMenuOpen = (event, menu) => {
        event.stopPropagation();
        setBlueSubMenu({anchorEl: event.currentTarget, subItems: menu.subItems});
    };

    const handleBlueSubMenuClose = () => {
        setBlueSubMenu(null);
    };

    const handleSettings = () => {
        handleUserMenuClose();
        navigate('/settings');
    };

    const handleUserMenuOpen = (event) => {
        setUserMenuAnchor(event.currentTarget);
    };

    const handleBurgerMenuOpen = (event) => {
        setBurgerMenuAnchor(event.currentTarget);
    };

    const handleNavItemClick = (item) => {
        handleBurgerMenuClose();
        if (item.requiresAuth && !profile) {
            requireAuthNavigate?.(item.path);
            return;
        }
        if (item.useLocationHref) {
            window.location.href = item.path;
        } else {
            navigate(item.path);
        }
    };

    const menuItemSx = {
        fontSize: '16px',
        lineHeight: '18px',
        color: (theme) => theme.palette.text.main,
    };

    return <AppBar
        position="static"
        sx={{
            width: '100%',
            minHeight: "76px",
            display: 'flex',
            justifyContent: "center",
            alignItems: 'center',
            backgroundColor: (theme) => theme.palette.primary.lightGrey,
            boxShadow: "none",
            '@media (max-width: 600px)': {
                minHeight: "64px",
            },
        }}>
        <Container sx={{
            "&.MuiContainer-root": {
                maxWidth: "1668px",
                ...(isKuhniVersoMebel ? kuhniVersoTabletContainerQuerySx : {}),
            }
        }}>
            <StyledToolbar>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexShrink: 0,
                }}>
                    {isKuhniVersoMebel ? (
                        <VersoMebelLogo
                            height={48}
                            textSizeScale={32 / 48}
                            fontWeight={800}
                            sx={{
                                marginRight: "40px",
                                "@media (max-width: 1100px)": {
                                    marginRight: "24px",
                                    "& > span[aria-label='VersoМебель']": {
                                        fontSize: "28px",
                                    },
                                },
                                "@media (max-width: 400px)": {
                                    "& > span[aria-label='VersoМебель']": {
                                        fontSize: "26px",
                                    },
                                },
                            }}
                        />
                    ) : isUpMe ? (
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="/"
                            sx={{
                                fontWeight: 800,
                                fontSize: "32px",
                                letterSpacing: '.3rem',
                                color: (theme) => theme.palette.primary.main,
                                textDecoration: 'none',
                                marginRight: "40px",
                                "@media (max-width: 1100px)": {
                                    fontSize: "28px",
                                    letterSpacing: ".2rem",
                                    marginRight: "24px",
                                },
                            }}
                        >
                            UpMe
                        </Typography>
                    ) : null}
                    {/*{profile && <SearchComponent placeholder={"Выберите город"}/>}*/}
                </Box>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flexGrow: 1,
                    minWidth: 0,
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        flexWrap: 'wrap',
                        gap: '8px 24px',
                        flexGrow: 1,
                        minWidth: 0,
                        textAlign: "left",
                        '& .MuiButton-root': {
                            fontSize: '16px',
                            lineHeight: '18px',
                            minWidth: 'unset',
                        },
                        '@media (max-width: 1200px)': {
                            gap: '8px 16px',
                        },
                        '@media (max-width: 1023px)': {
                            gap: '8px 16px',
                        },
                        '@media (max-width: 940px)': {
                            gap: '6px 12px',
                        },
                        '@media (max-width: 1023px)': {
                            display: 'none',
                        },
                    }}>
                        {!isKuhniVersoMebel && <ButtonText onClick={() => navigate('/help')} text={"Помощь"}></ButtonText>}
                        {isUpMe && <>
                            <ButtonText onClick={() => navigate('/stock')} text={"Акции"}></ButtonText>
                        </>}
                        {isKuhniVersoMebel && <>
                            <ButtonCatalog onClick={() => navigate('/catalog')} text={"Каталог"}></ButtonCatalog>
                            {!profile && (
                                <ButtonText
                                    onClick={() => navigate('/catalog/drafts')}
                                    text={"Мои черновики"}
                                />
                            )}
                            <ButtonText onClick={() => navigate('/how-to-order')} text={"Как сделать заказ?"}></ButtonText>
                        </>}
                        {(isUpMe || isKuhniVersoMebel) && <>
                            {!isKuhniVersoMebel && <ButtonText onClick={() => navigate('/news')} text={"Новости"}></ButtonText>}
                            <ButtonText onClick={() => navigate('/contacts')} text={"Контакты"}></ButtonText></>}
                        {isUpMe && <>
                            <ButtonText onClick={() => navigate('/all-materials')} text={"Материалы"}></ButtonText>
                            <ButtonText onClick={() => navigate('/work')} text={"Работа в UpMe"}></ButtonText>
                        </>}
                        {profile && !isOrganization && !isAdmin && !isKuhniVersoMebel && (
                            <ButtonBlue
                                text={"Оставить заявку"}
                                sx={{
                                    flexShrink: 1,
                                    minWidth: 0,
                                    width: 'auto',
                                    maxWidth: 172,
                                    lineHeight: '1 !important',
                                    px: '16px',
                                    '@media (max-width: 1200px)': {
                                        maxWidth: 148,
                                        height: 36,
                                    },
                                }}
                            />
                        )}
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0,
                        '@media (max-width: 1023px)': {
                            gap: '12px',
                        },
                        '@media (max-width: 400px)': {
                            gap: 0,
                        },
                    }}>
                        <Box sx={{flexShrink: 0, paddingLeft: '10px'}}>
                            <Button
                                aria-controls="user-menu-appbar"
                                aria-haspopup="true"
                                onClick={profile ? handleUserMenuOpen : () => handleChange(true)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textTransform: 'none',
                                    padding: 0,
                                    gridGap: "4px",
                                    "& svg": {
                                        width: "24px",
                                        height: "24px",
                                    },
                                    "& .MuiTypography-root": {
                                        fontSize: "12px",
                                        width: 84,
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        color: (theme) => profile ? theme.palette.text.main : theme.palette.text.light,
                                    },
                                    '@media (max-width: 1023px)': {
                                        width: '84px',
                                        minWidth: '84px',
                                        "& .MuiTypography-root": {
                                            width: '100%',
                                            whiteSpace: 'normal',
                                            overflow: 'visible',
                                            textOverflow: 'unset',
                                            textAlign: 'center',
                                            lineHeight: 1.2,
                                            wordBreak: 'break-word',
                                        },
                                    },
                                    '@media (max-width: 940px)': {
                                        width: '84px',
                                        minWidth: '84px',
                                    },
                                }}>
                                {profile ? <UserIcon/> : <UserLight/>}
                                <Typography>{profile ? profile.userName : "Войти"}</Typography>
                            </Button>
                            <Menu
                                id="user-menu-appbar"
                                anchorEl={userMenuAnchor}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                open={Boolean(userMenuAnchor)}
                                onClose={handleUserMenuClose}
                            >
                                <MenuItem onClick={() => {
                                    handleUserMenuClose();
                                    handleChange();
                                }}>Выйти</MenuItem>
                                <MenuItem onClick={handleSettings}>Настройки</MenuItem>
                            </Menu>
                        </Box>
                        {hasBurgerMenu && (
                        <IconButton
                            aria-label="Меню"
                            aria-controls="burger-menu-appbar"
                            aria-haspopup="true"
                            onClick={handleBurgerMenuOpen}
                            sx={{
                                display: 'none',
                                boxSizing: 'border-box',
                                width: 40,
                                minWidth: 40,
                                height: 24,
                                padding: 0,
                                marginLeft: '10px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: (theme) => theme.palette.text.main,
                                '@media (max-width: 1023px)': {
                                    display: 'inline-flex',
                                    marginLeft: 0,
                                },
                            }}
                        >
                            <MenuIcon sx={{width: 24, height: 24}}/>
                        </IconButton>
                        )}
                        <Menu
                            id="burger-menu-appbar"
                            anchorEl={burgerMenuAnchor}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            open={Boolean(burgerMenuAnchor)}
                            onClose={handleBurgerMenuClose}
                            MenuListProps={{
                                sx: {minWidth: 'unset'},
                            }}
                        >
                            {navItems.map((item) => (
                                <MenuItem
                                    key={item.path + item.label}
                                    onClick={() => handleNavItemClick(item)}
                                    sx={menuItemSx}
                                >
                                    {item.label}
                                </MenuItem>
                            ))}
                            {navItems.length > 0 && blueBarMenus.length > 0 && (
                                <Divider sx={{my: 0.5}}/>
                            )}
                            {blueBarMenus.map((menu) => (
                                <MenuItem
                                    key={menu.type}
                                    onClick={(event) => {
                                        if (menu.subItems.length > 0) {
                                            handleBlueSubMenuOpen(event, menu);
                                        }
                                    }}
                                    disabled={menu.subItems.length === 0}
                                    sx={{
                                        ...menuItemSx,
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: '8px',
                                    }}
                                >
                                    {menu.label}
                                    {menu.subItems.length > 0 && (
                                        <ChevronRightIcon sx={{fontSize: 20}}/>
                                    )}
                                </MenuItem>
                            ))}
                            {(navItems.length > 0 || blueBarMenus.length > 0)
                                && profile && !isOrganization && !isAdmin && !isKuhniVersoMebel && (
                                <Divider sx={{my: 0.5}}/>
                            )}
                            {profile && !isOrganization && !isAdmin && !isKuhniVersoMebel && (
                                <MenuItem onClick={handleBurgerMenuClose} sx={menuItemSx}>
                                    Оставить заявку
                                </MenuItem>
                            )}
                        </Menu>
                        <Menu
                            anchorEl={blueSubMenu?.anchorEl}
                            open={Boolean(blueSubMenu?.anchorEl)}
                            onClose={handleBlueSubMenuClose}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            MenuListProps={{
                                sx: {minWidth: 'unset'},
                            }}
                        >
                            {blueSubMenu?.subItems.map((item) => (
                                <MenuItem
                                    key={item.type}
                                    onClick={() => handleNavItemClick({path: item.hrefs, useLocationHref: true})}
                                    sx={menuItemSx}
                                >
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Box>
            </StyledToolbar>
        </Container>
    </AppBar>

}